<div class="container">

    <h1 class="text-center rounded text-black fw-bolder">ASSESSMENT OVERVIEW</h1>
<div class="d-flex gap-2">

    <mat-form-field appearance="outline">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input  [rangePicker]="picker">
            <input matStartDate [(ngModel)]="start" placeholder="Start date">
            <input matEndDate [(ngModel)]="end" placeholder="End date">
        </mat-date-range-input>
        <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

<!--        @if (range.controls.start.hasError('matStartDateInvalid')) {-->
<!--        <mat-error>Invalid start date</mat-error>-->
<!--        }-->
<!--        @if (range.controls.end.hasError('matEndDateInvalid')) {-->
<!--        <mat-error>Invalid end date</mat-error>-->
<!--        }-->
    </mat-form-field>
    <mat-form-field appearance="outline">
        <mat-label>Centre</mat-label>
        <mat-select [(value)]="selectedCentre" (selectionChange)="centreSelected()">
            <mat-option  value="All">All</mat-option>
            <mat-option *ngFor="let c of centres$|async"  [value]="c.centreCode">{{c.centreName}}</mat-option>
        </mat-select>
    </mat-form-field>
<!--    <mat-form-field appearance="outline">-->
<!--        <mat-label>Select Child</mat-label>-->
<!--        <mat-select [(value)]="selectedChild">-->
<!--            <mat-option *ngFor="let c of children$|async"  [value]="c">{{c.firstName}} {{c.lastName}}</mat-option>-->
<!--        </mat-select>-->
<!--    </mat-form-field>-->

  <mat-form-field appearance="outline" class="form-field-width">
    <mat-label>Select Child</mat-label>
    <mat-select [(value)]="selectedChild" (selectionChange)="OnChildSelected()" panelClass="custom-select-panel">
      <mat-select-trigger>
        {{ selectedChild ? selectedChild.firstName + ' ' + selectedChild.lastName : 'Select Child' }}
      </mat-select-trigger>
      <!-- Search Box -->
      <div class="mat-select-search">
        <input matInput [(ngModel)]="searchText" placeholder="Search" />
      </div>
      <!-- Filtered options -->
      <mat-option *ngFor="let c of children$ | async" [value]="c" style="height: auto">
        <ng-container *ngIf="!searchText || (c.firstName.toLowerCase().includes(searchText.toLowerCase()) || c.lastName.toLowerCase().includes(searchText.toLowerCase()))">
          {{ c.firstName }} {{ c.lastName }}
        </ng-container>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="d-flex gap-2 justify-content-start">
    <button mat-mini-fab (click)="search()" color="accent">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab (click)="clearFields()" color="accent">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>

    <section>



        <table class=" table table-striped table-bordered table-hover ">
            <thead class="thead-dark">
            <tr>
                <th>Centre</th>
                <th>Child Name</th>
                <th>Assessment Date</th>
                <!-- Loop through questions to generate headers -->
                <ng-container *ngIf="mData.length>=1">
                    <ng-container *ngFor="let question of mData[0].questions">
                        <th>{{ question.question }}</th>
<!--                        <th> Ans</th>-->
<!--                        <th> Remark</th>-->
                    </ng-container>
                </ng-container>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let assessment of mData">
                <td>{{ assessment.centreName }}</td>
                <td>{{ assessment.childName }}</td>
                <td>{{ assessment.dateOfAssessment.toDate()|date:'dd-MM-yyyy' }}</td>
                <!-- Loop through questions to display answers and remarks -->
                <ng-container *ngFor="let question of assessment.questions">
                    <td [matTooltip]="question.remark">{{ question.ans }}</td>
<!--                    <td>{{ question.remark }}</td>-->

                </ng-container>
<!--                <ng-container *ngFor="let question of assessment.questions">-->
<!--                    <td>{{ question.remark }}</td>-->
<!--                </ng-container>-->
            </tr>
            </tbody>
        </table>

    </section>
    <div class="d-flex justify-content-center">
    <app-apex-piechart
            *ngIf="mData.length>=1 "
            [chartLabels]="doughnutChartLabels"
            [chartTitle]="'Admission/Baseline Psychological Assessment'"

            [chartData]="apexChartData1">
    </app-apex-piechart>
    </div>

</div>
